import { useRouteMatch } from 'react-router';
import { createSelector } from '@reduxjs/toolkit';

import { useAppSelector } from 'js/store/hooks';
import { RootState } from 'js/types';

const getProjectSelector = createSelector(
  (state: RootState) => state.scribes.allScribes,
  (_: RootState, projectId: number) => projectId,
  (allScribes, projectId) => allScribes.find(scribe => scribe.id === projectId)
);

export function useProject() {
  const { params } = useRouteMatch<{ scribeId: string }>();
  const { scribeId: projectId } = params;
  const project = useAppSelector(state => getProjectSelector(state, Number(projectId)));
  return project;
}
